// ─────────────────────────────────────────────────────
// Sidebar — Persistent navigation for the web portal
// ─────────────────────────────────────────────────────
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Shirt, BarChart3, Palette,
  Share2, Settings, Zap, Camera,
} from "lucide-react";
import { clsx } from "clsx";

const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/wardrobe",  label: "Wardrobe",  icon: Shirt },
  { to: "/tryon",     label: "Try‑On",    icon: Camera, highlight: true },
  { to: "/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/style",     label: "Style",     icon: Palette },
  { to: "/social",    label: "Social",    icon: Share2 },
  { to: "/settings",  label: "Settings",  icon: Settings },
];

export function Sidebar() {
  return (
    <aside className="w-64 h-screen bg-sxt-surface border-r flex flex-col">
      {/* Logo */}
      <div className="px-6 py-5 border-b">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-sxt-primary flex items-center justify-center">
            <Zap className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-bold tracking-tight">SXT Portal</h1>
            <p className="text-xs text-sxt-muted">SmartMirror Dashboard</p>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV_ITEMS.map(({ to, label, icon: Icon, highlight }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              clsx(
                "flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors",
                isActive
                  ? "bg-sxt-primary/15 text-sxt-primary"
                  : highlight
                    ? "text-sxt-primary bg-sxt-primary/5 hover:bg-sxt-primary/10 border border-sxt-primary/20"
                    : "text-sxt-muted hover:text-sxt-text hover:bg-sxt-border/50"
              )
            }
          >
            <Icon className="w-5 h-5" />
            {label}
            {highlight && (
              <span className="ml-auto text-xs bg-sxt-primary text-black font-bold px-1.5 py-0.5 rounded-full">
                NEW
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* User */}
      <div className="px-4 py-4 border-t">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-sxt-primary flex items-center justify-center text-sm font-bold">
            U
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold truncate">SXT User</p>
            <p className="text-xs text-sxt-muted truncate">user@sxt.com</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
